var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-editor"},[_c('div',{ref:"rich",staticClass:"editor",staticStyle:{"text-align":"left"}})])}
var staticRenderFns = []

export { render, staticRenderFns }